import { render, staticRenderFns } from "./EmployeesAdminPage.vue?vue&type=template&id=b3877fec&scoped=true"
import script from "./EmployeesAdminPage.vue?vue&type=script&lang=js"
export * from "./EmployeesAdminPage.vue?vue&type=script&lang=js"
import style0 from "./EmployeesAdminPage.vue?vue&type=style&index=0&id=b3877fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3877fec",
  null
  
)

export default component.exports